var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarFont2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9375 1.25C6.18614 1.25 6.4246 1.34877 6.60041 1.52459C6.77623 1.7004 6.875 1.93886 6.875 2.1875V3.75H13.125V2.1875C13.125 1.93886 13.2238 1.7004 13.3996 1.52459C13.5754 1.34877 13.8139 1.25 14.0625 1.25C14.3111 1.25 14.5496 1.34877 14.7254 1.52459C14.9012 1.7004 15 1.93886 15 2.1875V3.75H17.5C17.8315 3.75 18.1495 3.8817 18.3839 4.11612C18.6183 4.35054 18.75 4.66848 18.75 5V17.5C18.75 17.8315 18.6183 18.1495 18.3839 18.3839C18.1495 18.6183 17.8315 18.75 17.5 18.75H2.5C2.16848 18.75 1.85054 18.6183 1.61612 18.3839C1.3817 18.1495 1.25 17.8315 1.25 17.5V5C1.25 4.66848 1.3817 4.35054 1.61612 4.11612C1.85054 3.8817 2.16848 3.75 2.5 3.75H5V2.1875C5 1.93886 5.09877 1.7004 5.27459 1.52459C5.4504 1.34877 5.68886 1.25 5.9375 1.25ZM3.125 5.625V7.5H16.875V5.625H3.125ZM3.125 16.875V9.375H16.875V16.875H3.125ZM13.75 13.75C14.0815 13.75 14.3995 13.6183 14.6339 13.3839C14.8683 13.1495 15 12.8315 15 12.5C15 12.1685 14.8683 11.8505 14.6339 11.6161C14.3995 11.3817 14.0815 11.25 13.75 11.25C13.4185 11.25 13.1005 11.3817 12.8661 11.6161C12.6317 11.8505 12.5 12.1685 12.5 12.5C12.5 12.8315 12.6317 13.1495 12.8661 13.3839C13.1005 13.6183 13.4185 13.75 13.75 13.75Z",
    fill: "#555F6E",
    stroke: "white",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFont2);
export default __webpack_public_path__ + "static/media/calendar_font2.39979208cb82e1e5b6bfe8b69917d029.svg";
export { ForwardRef as ReactComponent };